
export default [
  {
    url: '/home',
    name: 'Home',
    slug: "home",
    icon: 'HomeIcon',
  },

  // 提款
  {
    url: '/Address',
    name: 'Total Order Overview',
    slug: "Address",
    icon: 'GridIcon',
  },

  // 订单记录
  {
    url: '/transaction',
    name: 'BTC Transaction',
    slug: "transaction",
    icon: 'MenuIcon',
  },

  {
    url: '/tokenTransaction',
    name: 'ETH Transaction',
    slug: "ETH Transaction",
    icon: 'CopyIcon',
  },
  {
    url: '/trxOrder',
    name: 'TRX Order Overview',
    slug: "TRX Order Overview",
    icon: 'SlidersIcon',
  },
  {
    url: '/tronTokenTransaction',
    name: 'TRX Transaction',
    slug: "TRX Transaction",
    icon: 'LayersIcon',
  },
  {
    url: '/merchantWithdraw',
    name: 'Merchant Withdraw',
    slug: "Merchant Withdraw",
    icon: 'MinimizeIcon',
  },
  {
    url: '/orderList',
    name: 'Order List',
    slug: "orderList",
    icon: 'CheckIcon',
  }
  // {
  //   url: '/withdrawOrder',
  //   name: 'Withdraw Order',
  //   slug: "withdrawOrder",
  //   icon: 'LayersIcon',
  // },
  // {
  //   url: '/addressReq',
  //   name: 'Address Request',
  //   slug: "addressReq",
  //   icon: 'CpuIcon',
  // },
  // {
  //   url: '/logList',
  //   name: 'Log',
  //   slug: "logList",
  //   icon: 'SlidersIcon',
  // }
]



